import DisasterEvent_Minimal from './DisasterEvent_Minimal'

const DisasterEventFragments = { DisasterEvent_Minimal }

export default DisasterEventFragments
